import { render } from "./HeroiconsSolidRewind.vue?vue&type=template&id=42a730a9"
const script = {}

import exportComponent from "/Users/yllndritb/Projects/rent/rent-api/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidRewind.vue"]])

export default __exports__